import { exponentialBackoff } from '.'

export class Socket {
  constructor(url, streamId, onMessage, onError) {
    this.url = url
    this.streamId = streamId
    this.onMessage = onMessage
    this.onError = onError
    this.clientSocket = null
    this.retryingConnection = false
  }

  message(e, onMessage) {
    /* Receives response from server */
    const data = JSON.parse(e.data)
    onMessage(data)
  }

  heartbeat() {
    /* Checks for presence of server every 30 seconds */
    if (!this.clientSocket) return
    if (this.clientSocket.readyState !== 1) return
    this.clientSocket.send('heartbeat')
    setTimeout(this.heartbeat, 30000)
  }

  subscribe(streamId) {
    if (this.clientSocket.readyState === WebSocket.OPEN) {
      this.clientSocket.send(
        JSON.stringify({
          actions: [{ type: 'subscribe', service: streamId }],
        })
      )
    }
  }

  open(e) {
    /* Opens WebSockets communication */
    console.info('Socket open')
    this.heartbeat()
  }

  error(close = true) {
    /* Sends out socket error */
    console.warn('Socket error')
    if (this.onError) {
      this.onError()
    }
    if (!this.retryingConnection) {
      this.reconnect(close)
    }
  }

  reconnect(close) {
    this.retryingConnection = true
    /* Attempts reconnecting every second, after close event */
    console.info('Socket reconnnecting')
    if (close) {
      this.close()
    }
    exponentialBackoff(
      this.isConnected,
      8,
      1000,
      () => {
        this.retryingConnection = false
        console.info('Socket reconnected')
      },
      () => {
        //@TODO show notification we are attempting to reconnect and click to try now (like Slack)
        console.warn('Unable to reconnect')
      },
      true
    )
  }

  unsubscribe(streamId) {
    if (this.clientSocket.readyState === WebSocket.OPEN) {
      this.clientSocket.send(
        JSON.stringify({ actions: [{ type: 'unsubscribe', stream_id: streamId }] })
      )
    }
  }

  isConnected() {
    if (
      this.clientSocket.readyState !== WebSocket.OPEN ||
      this.clientSocket.readyState !== WebSocket.CONNECTING ||
      this.clientSocket.readyState === WebSocket.CLOSED
    ) {
      this.connect()
      return this.clientSocket.readyState === WebSocket.OPEN
    }
    return this.clientSocket.readyState === WebSocket.OPEN
  }

  close() {
    this.clientSocket.close()
  }

  connect() {
    /* Instantiates WebSockets events */
    if (this.clientSocket === null || this.clientSocket.readyState === WebSocket.CLOSED) {
      console.info('Initialising socket')
      try {
        this.clientSocket = new WebSocket(this.url)
        this.clientSocket.addEventListener('open', e => this.open(e))
        this.clientSocket.addEventListener('message', e => this.message(e, this.onMessage))
        this.clientSocket.addEventListener('error', this.error)
        this.clientSocket.addEventListener('close', () => {
          this.error(false)
        })
      } catch (e) {
        console.error(e)
      }
    }
  }
}
